import { EnumResponseModel } from '../Core';
import BaseApi, { SessionRequest } from '../Core/BaseApi';
import { AdminUser } from '../Entity/AdminUser';

/** Session fields returned by Login and stored in localStorage. */
export type AdminUserSession = Pick<
  AdminUser,
  | 'AdminUserId'
  | 'AccessToken'
  | 'Name'
  | 'Email'
  | 'Phone'
  | 'LoginId'
  | 'Address'
  | 'RoleId'
  | 'RoleName'
  | 'AllowedPageActionIds'
  | 'AllowedRoutePaths'
  | 'Permissions'
  | 'Status'
>;

export interface RolePageActionDto {
  PageActionId: string;
  RoutePath?: string;
  CanView: boolean;
  CanCreate: boolean;
  CanEdit: boolean;
  CanDelete: boolean;
  CanEditPrice: boolean;
}

/** Row shown on Admin User list / edit form. */
export type AdminUserListItem = Pick<
  AdminUser,
  | 'AdminUserId'
  | 'Name'
  | 'Email'
  | 'Phone'
  | 'LoginId'
  | 'Address'
  | 'RoleId'
  | 'RoleName'
  | 'Status'
>;

export type AdminUserLoginRequest = {
  LoginId: string;
  Password: string;
};

export type AdminUserWriteRequest = SessionRequest &
  Partial<
    Pick<AdminUser, 'Name' | 'Email' | 'Phone' | 'LoginId' | 'Address' | 'RoleId' | 'Status'>
  > & {
    AdminUserId?: string;
    Password?: string;
  };

export default class AdminUserDataService extends BaseApi {
  public static Login(model: AdminUserLoginRequest) {
    return this.BasePostRequestAsync<AdminUserSession>('AdminUser/Login', model);
  }

  public static Register(model: AdminUserWriteRequest) {
    const payload = { ...model };
    if (!payload.RoleId) {
      delete payload.RoleId;
    }
    return this.BasePostRequestAsync<AdminUserListItem>('AdminUser/Register', payload);
  }

  public static GetAllRegisterUsers(model: SessionRequest) {
    return this.BaseGetRequestAsync<AdminUserListItem[]>(
      'AdminUser/GetAllRegisterUsers',
      model,
    );
  }

  public static GetAllUserType(model: SessionRequest) {
    return this.BaseGetRequestAsync<EnumResponseModel[]>('AdminUser/GetAllUserType', model);
  }

  public static GetAllAdminUserStatusType(model: SessionRequest) {
    return this.BaseGetRequestAsync<EnumResponseModel[]>(
      'AdminUser/GetAllAdminUserStatusType',
      model,
    );
  }

  public static Update(model: AdminUserWriteRequest) {
    const payload = { ...model };
    if (!payload.RoleId) {
      delete payload.RoleId;
    }
    return this.BasePostRequestAsync<AdminUserListItem>('AdminUser/Update', payload);
  }

  public static LogOut(model: SessionRequest) {
    return this.BasePostRequestAsync<object>('AdminUser/Logout', model);
  }

  public static ChangePassword(model: SessionRequest & { OldPassword: string; NewPassword: string }) {
    return this.BasePostRequestAsync<object>('AdminUser/ChangePassword', model);
  }
}

/** @deprecated Prefer AdminUserLoginRequest */
export class AdminUserLogInRequestEntity {
  LoginId: string = '';
  Password: string = '';
}
